import { createReducer, on } from '@ngrx/store';
import { SettingStateInterface } from '../types';
import * as SettingsActions from './actions';

export const initialState: SettingStateInterface = {
  isLoading:        false,
  settingsData:      null,
  error:            null,
}

export const SettingsReducers = createReducer(
  initialState,
  on(SettingsActions.getSettingsData, (state) => ({...state , isLoading: true})),
  on(SettingsActions.getSettingsDataSuccess, (state, action ) => ({
    isLoading:        false,
    settingsData:      {
      language:                 action.language,
      jobNotification:          action.jobNotification,
      applicationNotification:  action.applicationNotification,
      profileNotification:      action.profileNotification,
      activityEmails:           action.activityEmails,
      meetingEmails:            action.meetingEmails,
      newsletterEmails:         action.newsletterEmails,
    },
    error: null,
  })),
  on(SettingsActions.getSettingsDataSuccessAlreadyLoaded, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(SettingsActions.updateLanguageSettingsData, (state, action ) => ({
    ...state,
    settingsData:      {
      language:                 action.language,
      jobNotification:          state.settingsData?.jobNotification,
      applicationNotification:  state.settingsData?.applicationNotification,
      profileNotification:      state.settingsData?.profileNotification,
      activityEmails:           state.settingsData?.activityEmails,
      meetingEmails:            state.settingsData?.meetingEmails,
      newsletterEmails:         state.settingsData?.newsletterEmails,
    },
  })),

  on(SettingsActions.updateNotificationSettingsData, (state, action ) => ({
    ...state,
    settingsData:      {
      language:                 state.settingsData?.language,
      jobNotification:          action.jobNotification,
      applicationNotification:  action.applicationNotification,
      profileNotification:      action.profileNotification,
      activityEmails:           state.settingsData?.activityEmails,
      meetingEmails:            state.settingsData?.meetingEmails,
      newsletterEmails:         state.settingsData?.newsletterEmails,
    },
  })),

  on(SettingsActions.updateEmailsSettingsData, (state, action ) => ({
    ...state,
    settingsData:      {
      language:                 state.settingsData?.language,
      jobNotification:          state.settingsData?.jobNotification,
      applicationNotification:  state.settingsData?.applicationNotification,
      profileNotification:      state.settingsData?.profileNotification,
      activityEmails:           action.activityEmails,
      meetingEmails:            action.meetingEmails,
      newsletterEmails:         action.newsletterEmails,
    },
  })),
  on(SettingsActions.getSettingsDataFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),

  on(SettingsActions.resetSettingsData, (state, action) => ({
    ...initialState,
  })),
);
